import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from "../../../../../constants/ActionTypes";
import MiddlewareEntities from "../../../../../constants/MiddlewareEntities";
import ManhattanTransitionMiddlewareProxy from './ManhattanTransitionMiddlewareProxy';

export const getOrderIdMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.GET_ORDER:
    ManhattanTransitionMiddlewareProxy.getOrder(next);
    break;
  default:
    break;
  }
};

export const fetchOrderMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.FETCH_ORDER:
    ManhattanTransitionMiddlewareProxy.fetchOrder(next, action.params);
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} ${ActionTypes.API_SUCCESS}` :
    ManhattanTransitionMiddlewareProxy.getOrderAPISuccess(next, store, action.payload.data);
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} ${ActionTypes.API_ERROR}` :
    ManhattanTransitionMiddlewareProxy.getOrderAPIError(store.getState(), next, action.payload);
    break;
  default:
    break;
  }
};

export const submitForNextStepMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.SUBMIT_ORDER_DATA_STEP:
    ManhattanTransitionMiddlewareProxy.submitOrderDataStep(next, action);
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN.NEXT_ORDER_DATA_STEP} ${ActionTypes.API_SUCCESS}` :
    ManhattanTransitionMiddlewareProxy.submitOrderDataStepAPISuccess(store, next, action.payload);
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN.NEXT_ORDER_DATA_STEP} ${ActionTypes.API_ERROR}` :
    ManhattanTransitionMiddlewareProxy.submitOrderDataStepAPIError(next, action);
    break;
  default:
    break;
  }
};

export const goToNextStepMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.GO_TO_NEXT_STEP:
    ManhattanTransitionMiddlewareProxy.goToNextStep(store.getState(), store, next, action.payload);
    break;
  default:
    break;
  }
};

export const submitForPreviousStepMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.SUBMIT_ORDER_PREVIOUS_DATA_STEP:
    ManhattanTransitionMiddlewareProxy.submitOrderPrevStep(next, action);
    break;
  case `${ MiddlewareEntities.ORDER.MANHATTAN.PREVIOUS_ORDER_DATA_STEP} ${ActionTypes.API_SUCCESS}` :
    ManhattanTransitionMiddlewareProxy.submitOrderPrevStepAPISuccess(next, store, action);
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN.PREVIOUS_ORDER_DATA_STEP} ${ActionTypes.API_ERROR}` :
    ManhattanTransitionMiddlewareProxy.submitOrderPrevStepAPIError(next, action);
    break;
  }
};

export const goToPreviousStepMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.GO_TO_PREVIOUS_STEP:
    ManhattanTransitionMiddlewareProxy.goToPreviousStep(store);
    break;
  default:
    break;
  }
};

export const orderValidatorMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.ORDER_VALIDATOR:
    ManhattanTransitionMiddlewareProxy.orderValidator(next, action.payload);
    break;
  default:
    break;
  }
};

export const orderInfoManhattanMiddleware = [
  getOrderIdMiddleware,
  fetchOrderMiddleware,
  goToNextStepMiddleware,
  goToPreviousStepMiddleware,
  submitForPreviousStepMiddleware,
  submitForNextStepMiddleware,
  orderValidatorMiddleware
];
